import React from 'react'
import * as msal from 'msal'
import jwt_decode from 'jwt-decode'

const state = {
  stopLoopingRedirect: false,
  config: {
    scopes: [],
    cacheLocation: null
  },
  launchApp: null,
  accessToken: null,
  userRole: null,
  msalObj: null,
  userName: null
}

const LOCAL_STORAGE = 'localStorage'
const SESSION_STORAGE = 'sessionStorage'
const AUTHORIZATION_KEY = 'Authorization'

var B2C_SCOPES = {
  API_ACCESS: {
    scopes: [process.env.REACT_APP_MSAL_B2C_SCOPE]
  }
}

var msalAppConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: process.env.REACT_APP_MSAL_AUTHORITY,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
    validateAuthority: false,
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'sessionStorage'
  }
}

function onSendRequest(request) {
  return msalApp.acquireTokenSilent(B2C_SCOPES.API_ACCESS).then(
    (response) => {
      state.accessToken = response.accessToken
      request.headers = {
        Authorization: `Bearer ${response.accessToken}`
      }

      return Promise.resolve(request)
    },
    (error) => {
      if (error) {
        msalApp.acquireTokenRedirect(B2C_SCOPES.API_ACCESS)
      }
    }
  )
}

function acquireToken(successCallback) {
  const account = msalApp.getAccount()
  if (!account) {
    msalApp.loginRedirect(B2C_SCOPES.API_ACCESS)
  } else {
    msalApp.acquireTokenSilent(B2C_SCOPES.API_ACCESS).then(
      (resp) => {
        if (msalAppConfig.cache.cacheLocation === LOCAL_STORAGE) {
          window.localStorage.setItem(
            AUTHORIZATION_KEY,
            'Bearer ' + resp.accessToken
          )
        } else if (msalAppConfig.cache.cacheLocation === SESSION_STORAGE) {
          window.sessionStorage.setItem(
            AUTHORIZATION_KEY,
            'Bearer ' + resp.accessToken
          )
        }

        state.accessToken = resp.accessToken

        const tokenInfo = jwt_decode(resp.accessToken)

        state.userRole = tokenInfo?.extension_role
        state.userName = `${tokenInfo?.given_name} ${tokenInfo?.family_name}`

        if (state.launchApp) {
          state.launchApp()
        }
        if (successCallback) {
          successCallback()
        }
      },
      (error) => {
        if (error) {
          msalApp.acquireTokenRedirect(B2C_SCOPES.API_ACCESS)
        }
      }
    )
  }
}

let msalApp

var authentication = {
  initialize: () => {
    msalApp = new msal.UserAgentApplication(msalAppConfig)
  },
  run: (launchApp) => {
    state.launchApp = launchApp
    msalApp.handleRedirectCallback((error) => {
      if (error) {
        const message = error.message
        if (
          message &&
          message.startsWith(
            process.env.REACT_APP_AZURE_ERROR_CODE_FORGOT_PASSWORD.toString()
          )
        ) {
          msalApp.authority =
            process.env.REACT_APP_MSAL_AUTHORITY_FORGOT_PASSWORD
          msalApp.loginRedirect(B2C_SCOPES.API_ACCESS)
        } else {
          const errorMessage = error.errorMessage
            ? error.errorMessage
            : 'Unable to acquire access token.'
          console.log(errorMessage)
        }
      }
    })
    acquireToken()
  },
  required: (WrappedComponent, renderLoading) => {
    return class extends React.Component {
      constructor(props) {
        super(props)
        this.state = {
          signedIn: true,
          error: null
        }
      }

      render() {
        if (this.state.signedIn) {
          return <WrappedComponent {...this.props} />
        }
        return typeof renderLoading === 'function' ? renderLoading() : null
      }
    }
  },

  signOut: () => {
    sessionStorage.removeItem(AUTHORIZATION_KEY)
    const logoutRequest = {
      account: msalApp.getAccount()
    }
    return msalApp.logout(logoutRequest)
  },
  handleOnSendRequest: (request) => {
    return onSendRequest(request)
  },
  getAccessToken: () => {
    return state.accessToken
  },
  getUserRole: () => {
    return state.userRole
  },
  getUserName: () => {
    return state.userName
  }
}

export default authentication
